import PropTypes from 'prop-types';
import React from 'react';

import AddressCustomFieldValue from './AddressCustomFieldValue';
import PhoneCustomFieldValue from './PhoneCustomFieldValue';
import TextAreaCustomFieldValue from './TextAreaCustomFieldValue';
import AssociationCustomFieldValue from './AssociationCustomFieldValue';
import GenericCustomFieldValue from './GenericCustomFieldValue';

const CrmPhoneWrapper = ({ customFieldValue, children }) => (
  <div className="row mt-3" style={{"padding": "10px 0 15px 0"}}>
    <div className="col-12">
      <div className="row">
        <div className="col-12">
          <p style={{"fontSize": "16px", "marginBottom": "12px"}}>
            <strong>{customFieldValue.custom_field.name}</strong>{!customFieldValue.custom_field.required ? " (optional)" : null}
          </p>
        </div>
      </div>
      <div className="form-row">
        {children}
      </div>
    </div>
  </div>
);

const CustomFieldValueFields = ({
  team,
  csrfToken,
  confirm,
  customFieldValues=[],
  customFieldValueChanged,
  highlightInvalidInputs=false,
  wrapPhoneInRow=false,
  crmLayout=false,
  defaultCountry,
  restrictCheckoutFiles=true,
  idSuffix
}) => (
  customFieldValues.sort((a, b) => a.custom_field.position - b.custom_field.position).map((customFieldValue, index) =>
    <React.Fragment key={index}>
      {customFieldValue.type === "CustomFieldValues::Address" ? (
        <AddressCustomFieldValue team={team}
                                 csrfToken={csrfToken}
                                 customFieldValue={customFieldValue}
                                 idSuffix={idSuffix}
                                 customFieldValueChanged={customFieldValueChanged}
                                 confirm={confirm}
                                 highlightInvalidInputs={highlightInvalidInputs}
                                 defaultCountry={defaultCountry} />
      ) : customFieldValue.type === "CustomFieldValues::Phone" ? (
        crmLayout ? (
          <CrmPhoneWrapper customFieldValue={customFieldValue}>
            <PhoneCustomFieldValue team={team}
                                   csrfToken={csrfToken}
                                   customFieldValue={customFieldValue}
                                   idSuffix={idSuffix}
                                   customFieldValueChanged={customFieldValueChanged}
                                   confirm={confirm}
                                   highlightInvalidInputs={highlightInvalidInputs} />
          </CrmPhoneWrapper>
        ) : wrapPhoneInRow ? (
          <div className="row mt-3">
            <PhoneCustomFieldValue team={team}
                                   csrfToken={csrfToken}
                                   customFieldValue={customFieldValue}
                                   idSuffix={idSuffix}
                                   customFieldValueChanged={customFieldValueChanged}
                                   confirm={confirm}
                                   highlightInvalidInputs={highlightInvalidInputs} />
          </div>
        ) : (
          <PhoneCustomFieldValue team={team}
                                 csrfToken={csrfToken}
                                 customFieldValue={customFieldValue}
                                 idSuffix={idSuffix}
                                 customFieldValueChanged={customFieldValueChanged}
                                 confirm={confirm}
                                 highlightInvalidInputs={highlightInvalidInputs} />
        )
      ) : customFieldValue.type === "CustomFieldValues::TextArea" ? (
        <TextAreaCustomFieldValue team={team}
                                 csrfToken={csrfToken}
                                 customFieldValue={customFieldValue}
                                 idSuffix={idSuffix}
                                 customFieldValueChanged={customFieldValueChanged}
                                 confirm={confirm} />
      ) : customFieldValue.type === "CustomFieldValues::Association" ? (
        <AssociationCustomFieldValue team={team}
                                     customFieldValue={customFieldValue}
                                     idSuffix={idSuffix}
                                     customFieldValueChanged={customFieldValueChanged} />
      ) : (
        <GenericCustomFieldValue
          customFieldValue={customFieldValue}
          idSuffix={idSuffix}
          customFieldValueChanged={customFieldValueChanged}
          restrictCheckoutFiles={restrictCheckoutFiles}
        />
      )}
    </React.Fragment>
  )
);

CustomFieldValueFields.propTypes = {
  team: PropTypes.object,
  csrfToken: PropTypes.string,
  confirm: PropTypes.object,
  customFieldValues: PropTypes.array,
  customFieldValueChanged: PropTypes.func.isRequired,
  highlightInvalidInputs: PropTypes.bool,
  wrapPhoneInRow: PropTypes.bool,
  crmLayout: PropTypes.bool,
  defaultCountry: PropTypes.string,
  restrictCheckoutFiles: PropTypes.bool,
  idSuffix: PropTypes.string
};

export default CustomFieldValueFields;
